import {clsx} from 'clsx';
import React from 'react';

import {type PlotFontSize} from '../../util/plotHelpers/plotFontSize';
import {TruncateTextTooltip} from '../common/TruncateText/TruncateTextTooltip';
import {TruncationType} from '../common/TruncateText/TruncateTextTypes';

export type PanelTitleViewProps = {
  disallowSelect?: boolean;
  fontSize?: PlotFontSize | 'auto';
  /** Marks search matches in the title; omit to show the plain title. */
  highlightSearch?: (title: string) => React.ReactNode;
  /** The user clicked the title. */
  onTitleClick: () => void;
  title: string;
};

/**
 * A panel title that truncates in the middle and shows the full title in a
 * tooltip when truncated. Reads only its props.
 */
export function PanelTitleView({
  disallowSelect,
  fontSize,
  highlightSearch,
  onTitleClick,
  title,
}: PanelTitleViewProps) {
  return (
    <TruncateTextTooltip
      data-dd-action-name="Panel title"
      className={clsx('PanelTitle', fontSize, {
        'select-none': disallowSelect,
      })}
      truncationType={TruncationType.Middle}
      fullText={title}
      highlight={highlightSearch}
      onClick={onTitleClick}
      noLink>
      title
    </TruncateTextTooltip>
  );
}
